module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information",
    attrs: {
      "flex": "dir:top",
      "flex-box": "1"
    }
  }, [_vm._m(0), (!_vm.success) ? _c('div', {
    staticClass: "form-box",
    attrs: {
      "flex-box": "1"
    }
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Essential information")]), _c('div', {
    staticClass: "input-box",
    attrs: {
      "flex": "dir:left main:justify cross:center"
    }
  }, [_c('div', {
    staticClass: "side-box",
    attrs: {
      "flex-box": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.firstName.value),
      expression: "from.firstName.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.firstName.isActive) && !_vm.from.firstName.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.from.firstName.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.firstName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.firstName, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.firstName.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("nameFilter")(_vm.from.firstName.value, _vm.from.firstName)))])]), _c('div', {
    staticClass: "side-box",
    attrs: {
      "flex-box": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.lastName.value),
      expression: "from.lastName.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.lastName.isActive) && !_vm.from.lastName.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.from.lastName.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.lastName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.lastName, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.lastName.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("nameFilter")(_vm.from.lastName.value, _vm.from.lastName)))])])]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.contactEmail.value),
      expression: "from.contactEmail.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.contactEmail.isActive) && !_vm.from.contactEmail.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.from.contactEmail.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.contactEmail)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.contactEmail, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.contactEmail.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("emailFilter")(_vm.from.contactEmail.value, _vm.from.contactEmail)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.phoneNumber.value),
      expression: "from.phoneNumber.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.phoneNumber.isActive) && !_vm.from.phoneNumber.isTrue
    },
    attrs: {
      "type": "number",
      "placeholder": "Phone Number",
      "oninput": "if(value.length>16)value=value.slice(0,16)"
    },
    domProps: {
      "value": (_vm.from.phoneNumber.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.phoneNumber)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.phoneNumber, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.phoneNumber.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("numFilter")(_vm.from.phoneNumber.value, _vm.from.phoneNumber)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.companyName.value),
      expression: "from.companyName.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.companyName.isActive) && !_vm.from.companyName.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.from.companyName.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.companyName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.companyName, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.companyName.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("charactersFilter")(_vm.from.companyName.value, _vm.from.companyName)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.companyWebsite.value),
      expression: "from.companyWebsite.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.companyWebsite.isActive) && !_vm.from.companyWebsite.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Company Website / Blog Site / Online presence"
    },
    domProps: {
      "value": (_vm.from.companyWebsite.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.companyWebsite)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.companyWebsite, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.companyWebsite.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.companyWebsite.value, _vm.from.companyWebsite)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.companyType.value),
      expression: "from.companyType.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.companyType.isActive) && !_vm.from.companyType.isTrue
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.companyType)
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.from.companyType, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Company type")]), _c('option', {
    attrs: {
      "value": "Recruiting company"
    }
  }, [_vm._v("Recruiting company")]), _c('option', {
    attrs: {
      "value": "ESL teaching program"
    }
  }, [_vm._v("ESL teaching program")]), _c('option', {
    attrs: {
      "value": "Blogger"
    }
  }, [_vm._v("Blogger")]), _c('option', {
    attrs: {
      "value": "Marketing agency"
    }
  }, [_vm._v("Marketing agency")]), _c('option', {
    attrs: {
      "value": "School staff"
    }
  }, [_vm._v("School staff")]), _c('option', {
    attrs: {
      "value": "Others"
    }
  }, [_vm._v("Others")])]), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.companyType.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.companyType.value, _vm.from.companyType)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.potentialTeacherNumber.value),
      expression: "from.potentialTeacherNumber.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.potentialTeacherNumber.isActive) && !_vm.from.potentialTeacherNumber.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Number of potential teachers in your network"
    },
    domProps: {
      "value": (_vm.from.potentialTeacherNumber.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.potentialTeacherNumber)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.potentialTeacherNumber, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.potentialTeacherNumber.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.potentialTeacherNumber.value, _vm.from.potentialTeacherNumber)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.businessDescription.value),
      expression: "from.businessDescription.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.businessDescription.isActive) && !_vm.from.businessDescription.isTrue
    },
    attrs: {
      "placeholder": "Description of your business"
    },
    domProps: {
      "value": (_vm.from.businessDescription.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.businessDescription)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.businessDescription, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.businessDescription.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.businessDescription.value, _vm.from.businessDescription)))])]), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.channels.value),
      expression: "from.channels.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.channels.isActive) && !_vm.from.channels.isTrue
    },
    attrs: {
      "placeholder": "Through what channels will you market to potential teachers"
    },
    domProps: {
      "value": (_vm.from.channels.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.channels)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.channels, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.channels.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("allFilter")(_vm.from.channels.value, _vm.from.channels)))])]), _c('div', {
    staticClass: "input-box verification-box",
    attrs: {
      "flex": "dir:left"
    }
  }, [_c('div', {
    staticClass: "side-box verify-code-input",
    attrs: {
      "flex-box": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.imageCode.value),
      expression: "from.imageCode.value"
    }],
    class: {
      'error_input': (_vm.showError || _vm.from.imageCode.isActive) && !_vm.from.imageCode.isTrue
    },
    attrs: {
      "type": "text",
      "placeholder": "Verification code"
    },
    domProps: {
      "value": (_vm.from.imageCode.value)
    },
    on: {
      "blur": function($event) {
        return _vm.changeActive(_vm.from.imageCode)
      },
      "focus": _vm.focusImageCode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.from.imageCode, "value", $event.target.value)
      }
    }
  }), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.imageCode.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("imageCodeFilter")(_vm.from.imageCode.value, _vm.from.imageCode)))])]), _c('div', {
    staticClass: "side-box verify-code-img",
    attrs: {
      "flex-box": "0"
    }
  }, [_c('img', {
    attrs: {
      "alt": "verification code",
      "src": _vm.imageCodeImgSrc
    },
    on: {
      "click": function($event) {
        return _vm.getVerifyCode()
      }
    }
  })])]), _c('div', {
    staticClass: "label-box auto"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from.isAgree.value),
      expression: "from.isAgree.value"
    }],
    attrs: {
      "name": "is-agree",
      "type": "checkbox",
      "id": "all-agree",
      "value": "value"
    },
    domProps: {
      "checked": Array.isArray(_vm.from.isAgree.value) ? _vm._i(_vm.from.isAgree.value, "value") > -1 : (_vm.from.isAgree.value)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.from.isAgree.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "value",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.from.isAgree, "value", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.from.isAgree, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.from.isAgree, "value", $$c)
        }
      }
    }
  }), _vm._m(1), _c('p', {
    staticClass: "error",
    class: {
      'show-error': _vm.showError || _vm.from.isAgree.isActive
    }
  }, [_vm._v(_vm._s(_vm._f("agreeFilter")(_vm.from.isAgree.value, _vm.from.isAgree)))])]), _c('div', {
    staticClass: "btn-box",
    attrs: {
      "flex": "dir:left"
    }
  }, [_c('div', {
    staticClass: "btn",
    attrs: {
      "flex-box": "0"
    },
    on: {
      "click": _vm.validateFrom
    }
  }, [_vm._v("Apply")])])])]) : _c('div', {
    staticClass: "success-box",
    attrs: {
      "flex-box": "1"
    }
  }, [_vm._m(2)]), _c('div', {
    staticClass: "tp-footer",
    attrs: {
      "flex-box": "0"
    }
  }, [_vm._v("© VIPKID Beijing ICP 14002500")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-banner",
    attrs: {
      "flex": "dir:left main:justify cross:center",
      "flex-box": "0"
    }
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "https://www.vipkid.com/mkt/affiliate-program",
      "flex-box": "0"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./logo.png")
    }
  })]), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/login",
      "flex-box": "0"
    }
  }, [_vm._v("Sign In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "all-agree"
    }
  }, [_vm._v("By entering my own name/company name below, l warrant that l have read and understand\nfully the content and meaning of the "), _c('a', {
    staticClass: "import",
    attrs: {
      "href": "/protocol",
      "target": "_blank"
    }
  }, [_vm._v("Referral Service Agreement")]), _vm._v(" and l am willing to enter into this agreement and agreed all terms of the agreement,\nincluding but not limited to arbitration clause and class action waiver, and no action\nwill be taken by or on behalf of the undersigned with respect to any such terms.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-bg",
    attrs: {
      "flex": "cross:center main:center"
    }
  }, [_c('div', {
    staticClass: "tips",
    attrs: {
      "flex": "dir:left cross:top main:center"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./success-tips.png")
    }
  })]), _c('div', {
    staticClass: "msg"
  }, [_c('h2', [_vm._v("Your information has been submitted.")]), _c('p', [_vm._v("Thank you for your interest in becoming our affiliate partner! Our team\nwill review your application and get back to you via email in 5 business days.")]), _c('a', {
    attrs: {
      "href": "https://www.vipkid.com/mkt/affiliate-program",
      "target": "_blank"
    }
  }, [_vm._v("Learn more about the affiliate program >")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73bd7b58!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/information.vue
// module id = 299
// module chunks = 2